import classNames from 'clsx';
import React from 'react';

import type { FootballFixture } from '@swf/generated/graphql/scoreboards/schemas';
import type { Participants } from '@swf/sports/types/event';
import type { Orientation } from '@swf/sports/types/scoreboards';

import styles from './FootballScoreboard.scss';

interface Props {
  participants: Participants;
  footballFixture: FootballFixture;
  orientation: Orientation;
}

const FootballScoreboard: React.FC<Props> = ({ participants, footballFixture, orientation }) => {
  const [home, away] = participants;
  const { score, penaltyShootout } = footballFixture;

  return (
    <div
      data-testid="football-scoreboard"
      className={classNames(styles.container, {
        [styles.horizontal]: orientation === 'horizontal'
      })}
    >
      <span className={classNames(styles.name, styles.homeName)}>{home}</span>
      <span
        data-testid="scoreboard-home-score"
        className={classNames(styles.score, styles.homeScore, {
          [styles.inactive]: !!penaltyShootout
        })}
      >
        {score?.home ?? '-'}
      </span>
      {orientation === 'horizontal' && (
        <span className={classNames(styles.score, styles.separator)}>{' - '}</span>
      )}
      <span className={classNames(styles.name, styles.awayName)}>{away}</span>
      <span
        data-testid="scoreboard-away-score"
        className={classNames(styles.score, styles.awayScore, {
          [styles.inactive]: !!penaltyShootout
        })}
      >
        {score?.away ?? '-'}
      </span>
    </div>
  );
};

export default FootballScoreboard;
